var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-marker-cluster',_vm._l((_vm.latLngs),function(latlng,i){return _c('l-marker',{key:i,attrs:{"icon":_vm.defaultIcon,"lat-lng":[latlng.lat, latlng.lng]}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }